export enum ExpirationContext {
	SSO_LINK = 1,
	EMBED_TOKEN
}
